import {makeAutoObservable, extendObservable} from "mobx";

/**
 * 공통 - 사람
 */
export default class TbComPerson {
    private _personId: string = "";
    private _emailAdres: string = "";
    private _personNm: string = "";
    private _writngPsnId: string = "";
    private _writngDt!: Date;
    private _changePsnId: string = "";
    private _changeDt!: Date;
    private _bizNo: string = "";
    private _corpRegNo: string = "";
    private _corpNm: string = "";
    private _deptNm: string = "";
    private _posiNm: string = "";
    private _ofcTelNo: string = "";
    private _hpNo: string = "";
    private _userTpCd: string = "";
    private _emailApprYn: boolean = false;
    private _emailApprDate!: Date;
    private _emailApprKey: string = "";
    private _apprYn: boolean = false;
    private _apprUserid: string = "";
    private _apprDate!: Date;
    private _useYn: boolean = false;

    public constructor(data?) {
        if (data) extendObservable(this, data);
        else makeAutoObservable(this);
    }

    get apprUserid() {
        return this._apprUserid;
    }

    set apprUserid(value: string) {
        this._apprUserid = value;
    }

    get apprYn(): boolean {
        return this._apprYn;
    }

    set apprYn(value: boolean) {
        this._apprYn = value;
    }

    get emailApprKey() {
        return this._emailApprKey;
    }

    set emailApprKey(value: string) {
        this._emailApprKey = value;
    }

    get emailApprDate(): Date {
        return this._emailApprDate;
    }

    set emailApprDate(value: Date) {
        this._emailApprDate = value;
    }

    get emailApprYn(): boolean {
        return this._emailApprYn;
    }

    set emailApprYn(value: boolean) {
        this._emailApprYn = value;
    }

    get userTpCd() {
        return this._userTpCd;
    }

    set userTpCd(value: string) {
        this._userTpCd = value;
    }

    get hpNo() {
        return this._hpNo;
    }

    set hpNo(value: string) {
        this._hpNo = value;
    }

    get ofcTelNo() {
        return this._ofcTelNo;
    }

    set ofcTelNo(value: string) {
        this._ofcTelNo = value;
    }

    get posiNm() {
        return this._posiNm;
    }

    set posiNm(value: string) {
        this._posiNm = value;
    }

    get apprDate(): Date {
        return this._apprDate;
    }

    set apprDate(value: Date) {
        this._apprDate = value;
    }

    get useYn(): boolean {
        return this._useYn;
    }

    set useYn(value: boolean) {
        this._useYn = value;
    }

    get deptNm() {
        return this._deptNm;
    }

    set deptNm(value: string) {
        this._deptNm = value;
    }

    get bizNo() {
        return this._bizNo;
    }

    set bizNo(value: string) {
        this._bizNo = value;
    }

    get corpRegNo(): string {
        return this._corpRegNo;
    }

    set corpRegNo(value: string) {
        this._corpRegNo = value;
    }

    get corpNm(): string {
        return this._corpNm;
    }

    set corpNm(value: string) {
        this._corpNm = value;
    }

    get changeDt(): Date {
        return this._changeDt;
    }

    set changeDt(value: Date) {
        this._changeDt = value;
    }

    get changePsnId() {
        return this._changePsnId;
    }

    set changePsnId(value: string) {
        this._changePsnId = value;
    }

    get writngDt(): Date {
        return this._writngDt;
    }

    set writngDt(value: Date) {
        this._writngDt = value;
    }

    get writngPsnId() {
        return this._writngPsnId;
    }

    set writngPsnId(value: string) {
        this._writngPsnId = value;
    }

    get personNm() {
        return this._personNm;
    }

    set personNm(value: string) {
        this._personNm = value;
    }

    get emailAdres() {
        return this._emailAdres;
    }

    set emailAdres(value: string) {
        this._emailAdres = value;
    }

    get personId() {
        return this._personId;
    }

    set personId(value: string) {
        this._personId = value;
    }
}
